'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appName = appName;
exports.isApp = isApp;

var _AppConfigContainer = require('../globals/AppConfigContainer');

var _AppConfigContainer2 = _interopRequireDefault(_AppConfigContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function appName() {
  return _AppConfigContainer2.default.get('appName');
}

function isApp(whichApp) {
  return appName() === whichApp;
}